import { render, staticRenderFns } from "./RecentTable.vue?vue&type=template&id=579de01a&"
import script from "./RecentTable.vue?vue&type=script&lang=js&"
export * from "./RecentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports